import React from "react";

function isUnicodeEmoji(value) {
    if (!value || typeof value !== "string") return false;
    const trimmed = value.trim();
    if (!trimmed || /[<>]/.test(trimmed) || trimmed.includes("xmlns")) {
        return false;
    }
    return !trimmed.startsWith("<");
}

export default function SvgPrinter({ svg, label }) {
    const containerRef = React.useRef();
    const nativeEmoji = isUnicodeEmoji(svg);

    React.useEffect(() => {
        if (!containerRef.current || !svg) return;

        if (nativeEmoji) {
            containerRef.current.textContent = svg.trim();
        } else {
            containerRef.current.innerHTML = svg;
        }
    }, [svg, nativeEmoji]);

    return (
        <span
            ref={containerRef}
            className={`emoji-display${
                nativeEmoji ? " emoji-display--native" : ""
            }`}
            role="img"
            aria-label={label || (nativeEmoji ? svg.trim() : "emoji")}
        />
    );
}
